import { Component, Inject, Input } from "angular-ts-decorators";

import { ICompareCheckboxService } from "src/Foundation/Design/platform";

import template from "./compare-basket-buttons.component.html";

@Component({
  selector: "compareBasketButtons",
  template
})
export class CompareBasketButtonsComponent {
  public static $inject: ReadonlyArray<string> = ["compareCheckboxService"];

  @Input() public productids: number[];

  constructor(
    @Inject("compareCheckboxService") private compareCheckboxService: ICompareCheckboxService,
  ) { }

  public get comparePageUrl(): string {
    return `/compare-products?productids=${this.productids}`;
  }

  public removeAllProducts(): void {
    return this.compareCheckboxService.clearAll(this.productids);
  }

  public get isDisabled(): boolean {
    return this.productids.length <= 1;
  }
}
